import { render, staticRenderFns } from "./AdminSettingsMenu.vue?vue&type=template&id=96477e70"
import script from "./AdminSettingsMenu.vue?vue&type=script&lang=js"
export * from "./AdminSettingsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports